define("shared/components/shared/post/secondary/high-performer/wrapper", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "tracked-built-ins", "later/models/gram", "later/utils/constants/segment-events", "later/utils/fetch", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _trackedBuiltIns, _gram, _segmentEvents, _fetch, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _setPostMediaItemAnalaytics, _getIsMetricAchieved, _getValue;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"tracked-built-ins",0,"later/models/gram",0,"later/utils/constants/segment-events",0,"later/utils/fetch",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class={{unless
      this.isAnalyticsRoute
      "o--modalCard--secondary tHP--modalCard"
      "o--modalCard tHP--modalCard u--m__b__lg"
    }}
    data-test-id="high-performer-modal"
    {{did-insert (perform this.loadAnalytics)}}
  >
    <div class="o--modalHeader tHP--modalHeader">
      <p class="o--modalHeader__title tHP--modalHeader__title">
        {{svg-jar "high-performing" class="o--icon--lg o--icon--hl u--m__r"}}
        {{t "shared_phrases.high_performer.title"}}
      </p>
    </div>
  
    <div
      class={{unless
        this.isAnalyticsRoute
        "o--modalBody--secondary tHP--modalBody--secondary"
        "o--modalBody tHP--modalBody"
      }}
      {{perfect-scroll}}
    >
      {{! Stats }}
      <div class="u--row u--row--noCollapse u--m__b">
        {{#each this.postAnalytics as |postAnalytic|}}
          <div class="u--col__4">
            <div class={{concat-classes "tHP--statBox" (if postAnalytic.isMetricAchieved "is--success")}}>
              {{svg-jar
                postAnalytic.icon
                class=(concat-classes
                  "o--icon--md u--m__b__xs" (if postAnalytic.isMetricAchieved "o--icon--success" "o--icon--grey")
                )
              }}
              <span class="tHP--statBox__label">{{postAnalytic.description}}</span>
              <span>{{postAnalytic.value}}</span>
              {{#if postAnalytic.average}}
                <span class="tHP--statBox__average">{{postAnalytic.average}}%</span>
              {{/if}}
            </div>
          </div>
        {{/each}}
      </div>
      {{! Actions }}
      {{#each this.postActions as |postAction|}}
        {{#if postAction.isActive}}
          <div class="tHP--actionBox u--m__b__sm u--p__lr__md">
            <Shared::Ui::Button
              @additional="block"
              @class="o--btn--r"
              @onClick={{postAction.onClickAction}}
              @variant="default"
              type="button"
            >
              {{svg-jar postAction.buttonIcon class="o--icon"}}
              {{postAction.buttonText}}
            </Shared::Ui::Button>
            <p class="tHP--actionBox__desc">{{postAction.description}}</p>
          </div>
        {{/if}}
      {{/each}}
    </div>
  </div>
  */
  {
    "id": "df6a/VBf",
    "block": "[[[11,0],[16,0,[52,[51,[30,0,[\"isAnalyticsRoute\"]]],\"o--modalCard--secondary tHP--modalCard\",\"o--modalCard tHP--modalCard u--m__b__lg\"]],[24,\"data-test-id\",\"high-performer-modal\"],[4,[38,1],[[28,[37,2],[[30,0,[\"loadAnalytics\"]]],null]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--modalHeader tHP--modalHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--modalHeader__title tHP--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"high-performing\"],[[\"class\"],[\"o--icon--lg o--icon--hl u--m__r\"]]]],[1,\"\\n      \"],[1,[28,[35,4],[\"shared_phrases.high_performer.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[11,0],[16,0,[52,[51,[30,0,[\"isAnalyticsRoute\"]]],\"o--modalBody--secondary tHP--modalBody--secondary\",\"o--modalBody tHP--modalBody\"]],[4,[38,5],null,null],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"u--row u--row--noCollapse u--m__b\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"postAnalytics\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n          \"],[10,0],[15,0,[28,[37,8],[\"tHP--statBox\",[52,[30,1,[\"isMetricAchieved\"]],\"is--success\"]],null]],[12],[1,\"\\n            \"],[1,[28,[35,3],[[30,1,[\"icon\"]]],[[\"class\"],[[28,[37,8],[\"o--icon--md u--m__b__xs\",[52,[30,1,[\"isMetricAchieved\"]],\"o--icon--success\",\"o--icon--grey\"]],null]]]]],[1,\"\\n            \"],[10,1],[14,0,\"tHP--statBox__label\"],[12],[1,[30,1,[\"description\"]]],[13],[1,\"\\n            \"],[10,1],[12],[1,[30,1,[\"value\"]]],[13],[1,\"\\n\"],[41,[30,1,[\"average\"]],[[[1,\"              \"],[10,1],[14,0,\"tHP--statBox__average\"],[12],[1,[30,1,[\"average\"]]],[1,\"%\"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"postActions\"]]],null]],null],null,[[[41,[30,2,[\"isActive\"]],[[[1,\"        \"],[10,0],[14,0,\"tHP--actionBox u--m__b__sm u--p__lr__md\"],[12],[1,\"\\n          \"],[8,[39,10],[[24,4,\"button\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",\"o--btn--r\",[30,2,[\"onClickAction\"]],\"default\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,3],[[30,2,[\"buttonIcon\"]]],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n            \"],[1,[30,2,[\"buttonText\"]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[10,2],[14,0,\"tHP--actionBox__desc\"],[12],[1,[30,2,[\"description\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[2]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"postAnalytic\",\"postAction\"],false,[\"unless\",\"did-insert\",\"perform\",\"svg-jar\",\"t\",\"perfect-scroll\",\"each\",\"-track-array\",\"concat-classes\",\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/high-performer/wrapper.hbs",
    "isStrictMode": false
  });
  let WrapperComponent = _exports.default = (_dec = (0, _object.computed)('postMediaItemAnalytics'), _dec2 = (0, _object.computed)('postMediaItemAnalytics'), (_class = (_setPostMediaItemAnalaytics = /*#__PURE__*/new WeakSet(), _getIsMetricAchieved = /*#__PURE__*/new WeakSet(), _getValue = /*#__PURE__*/new WeakSet(), class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _getValue);
      _classPrivateMethodInitSpec(this, _getIsMetricAchieved);
      _classPrivateMethodInitSpec(this, _setPostMediaItemAnalaytics);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);
      _defineProperty(this, "postMediaItemAnalytics", new _trackedBuiltIns.TrackedObject());
      _defineProperty(this, "emptyValueCharacter", '-');
      _defineProperty(this, "loadAnalytics", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const socialProfileId = this.args.socialProfile.id;
          const {
            mediaId
          } = this.args.post;
          try {
            const response = yield (0, _fetch.fetch)(`/api/v2/analytics/media.json?social_profile_id=${socialProfileId}&ids[]=${mediaId}`);
            _classPrivateMethodGet(this, _setPostMediaItemAnalaytics, _setPostMediaItemAnalaytics2).call(this, response.media);
          } catch (error) {
            this.errors.log(new Error('Error while fetching high-performing post analytics'), {
              socialProfileId,
              mediaId: mediaId || '',
              error
            });
          }
        }
      }), null, "loadAnalytics", null));
    }
    get postAnalytics() {
      return [{
        average: undefined,
        description: this.intl.t('shared_words.likes'),
        icon: 'liked',
        isMetricAchieved: _classPrivateMethodGet(this, _getIsMetricAchieved, _getIsMetricAchieved2).call(this, _gram.MetricsAchieved.LikeCount),
        value: _classPrivateMethodGet(this, _getValue, _getValue2).call(this, _gram.MetricsAchieved.LikeCount)
      }, {
        average: undefined,
        description: this.intl.t('shared_words.reach'),
        icon: 'view',
        isMetricAchieved: _classPrivateMethodGet(this, _getIsMetricAchieved, _getIsMetricAchieved2).call(this, _gram.MetricsAchieved.Reach),
        value: _classPrivateMethodGet(this, _getValue, _getValue2).call(this, _gram.MetricsAchieved.Reach)
      }, {
        average: undefined,
        description: this.intl.t('shared_words.comments'),
        icon: 'comment',
        isMetricAchieved: _classPrivateMethodGet(this, _getIsMetricAchieved, _getIsMetricAchieved2).call(this, _gram.MetricsAchieved.CommentCount),
        value: _classPrivateMethodGet(this, _getValue, _getValue2).call(this, _gram.MetricsAchieved.CommentCount)
      }];
    }
    get postActions() {
      return [{
        description: this.intl.t('shared_phrases.high_performer.copy'),
        buttonIcon: 'copy',
        buttonText: this.intl.t('post.copy_post.copy_post'),
        isActive: true,
        onClickAction: () => this.args.toggleCopyPostModal()
      }, {
        description: this.intl.t('shared_phrases.high_performer.performance'),
        buttonIcon: 'trending-up',
        buttonText: this.intl.t('shared_phrases.view_performance'),
        isActive: !this.args?.hidePerformanceLink,
        onClickAction: () => this.navigateToAnalytics()
      }, {
        description: this.intl.t('shared_phrases.high_performer.engage'),
        buttonIcon: 'social-inbox',
        buttonText: this.intl.t('shared_phrases.view_social_inbox'),
        isActive: this.canNavigateToComments,
        onClickAction: () => this.navigateToConversation()
      }];
    }
    get isAnalyticsRoute() {
      return this.router.currentRouteName.includes('analytics');
    }
    get mediaId() {
      return this.args.post.mediaId;
    }
    get urlName() {
      return this.args.socialProfile.urlName;
    }
    get socialProfileId() {
      return this.args.socialProfile.id;
    }
    get canNavigateToComments() {
      return Boolean(this.postMediaItemAnalytics[_gram.MetricsAchieved.CommentCount]);
    }
    get hasAnalyticsStandardAccess() {
      if (this.args.post.isInstagram) {
        const isLegacy = this.auth.currentAccount.isOnLegacyPlan;
        return isLegacy ? this.subscriptions.isPaid : !!this.subscriptions.subscriptionPlan?.features?.analytics_standard;
      }
      return true;
    }
    get analyticsPath() {
      const {
        profileType
      } = this.args.socialProfile;
      if (this.args.post.isInstagram) {
        return this.hasAnalyticsStandardAccess ? `cluster.analytics.profile.${profileType}.posts.lifespan` : `cluster.analytics.profile.${profileType}.posts`;
      }
      return `cluster.analytics.profile.${profileType}.overview.lifespan`;
    }
    navigateToAnalytics() {
      this.segment.track(_segmentEvents.SegmentEventTypes.ClickedViewComments, {
        high_performing_content: this.args.post.isHighPerformingPost
      });
      if (this.hasAnalyticsStandardAccess && this.mediaId) {
        this.router.transitionTo(this.analyticsPath, this.urlName, this.mediaId);
      } else {
        this.router.transitionTo(this.analyticsPath, this.urlName);
      }
      return;
    }
    navigateToConversation() {
      if (this.mediaId) {
        this.router.transitionTo('cluster.inbox.conversation', this.socialProfileId, this.mediaId);
      } else {
        this.router.transitionTo('cluster.inbox');
      }
      return;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "postAnalytics", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "postAnalytics"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canNavigateToComments", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "canNavigateToComments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToAnalytics", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToAnalytics"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToConversation", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToConversation"), _class.prototype)), _class));
  function _setPostMediaItemAnalaytics2(postMediaItemsAnalytics) {
    (0, _object.set)(this, 'postMediaItemAnalytics', postMediaItemsAnalytics.find(postMediaItemAnalytics => postMediaItemAnalytics.id === this.mediaId));
  }
  function _getIsMetricAchieved2(metric) {
    return Boolean(this.args.post.metricsAchieved?.includes(metric));
  }
  function _getValue2(metric) {
    const value = this.postMediaItemAnalytics[metric];
    return value ? value.toLocaleString() : this.emptyValueCharacter;
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});